import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import TitleBar from "../../components/TitleBar";
import { ivrListRequest } from "../../actions/ivrActions";
import { login, logout } from "../../actions/middleware_actions";
import { mapIvrStateToProps } from "../../services/mapStateToProps";
import {
  ivrRequest,
  login_request,
  checkTokenValid,
  checkLoginFailure,
} from "../../constants/default_request";
import { loadIvrTrip } from "../../actions/ivrTripStorage";
import Spinner from "../../components/common/Spinner";
import IvrList from "./GarfoIvrList";
import Alert from "@mui/material/Alert";
import SavedTrip from "./IvrSavedTrips";
import Token from "../../components/common/RefreshToken";

function IvrListPage({
  ivrs,
  errors,
  auth,
  ivrListRequest,
  userLogin,
  userLogout,
  apiErrors,
}) {
  const location = useLocation();
  const vesselNbr = location.state.vesselNbr;
  const trip_id = location.state.trip_id;
  const [action, setAction] = useState({ enabled: false });
  const { client_id, token, user_app_status } = auth;
  const payload = ivrRequest(client_id, token, user_app_status, vesselNbr);
  const [storedTrip, setStoredTrip] = useState(false);
  let savedTrips = loadIvrTrip(client_id);
  const isTokenValid = checkTokenValid(auth);
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const username = userInfo ? userInfo.username : "";
  const didLoginFail = checkLoginFailure(apiErrors);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    didLoginFail ? setOpenDialog(true) : setOpenDialog(false);
  }, [didLoginFail]);

  useEffect(() => {
    if (!isTokenValid) {
      setOpenDialog(true);
      return;
    }

    ivrListRequest(payload);

    if (Object.keys(savedTrips).length > 0) setStoredTrip(true);
    // eslint-disable-next-line
  }, [ivrListRequest, isTokenValid]);

  return (
    <>
      {action.enabled && (
        <Navigate
          to={`${process.env.PUBLIC_URL}/${action.endPoint}`}
          state={{
            trip_id: action.type.includes("close") ? action.trip_id : trip_id,
            vtr_nbr: trip_id,
            tripType: action.tripType,
            projectCode: action.projectCode || "",
            auth,
            permitNbr: vesselNbr,
            type: action.type,
            username,
          }}
        />
      )}

      {storedTrip && (
        <SavedTrip vesselNbr={vesselNbr} status={true} trip={savedTrips} />
      )}

      {openDialog && (
        <Token
          user={username}
          loginRequest={login_request}
          loginUser={userLogin}
          logoutUser={userLogout}
          toggleDialog={handleClose}
        />
      )}

      <TitleBar title="GARFO IVR" />
      {Object.entries(errors).length > 0 ? (
        <Alert severity="error">
          {errors.hasOwnProperty("ERRORS") ? errors.ERRORS : errors.message}
        </Alert>
      ) : Object.entries(ivrs).length === 0 ? (
        <Spinner />
      ) : (
        <IvrList ivrs={ivrs} vesselNbr={vesselNbr} handleAction={setAction} />
      )}
    </>
  );
}

const mapDispatchToProps = {
  ivrListRequest,
  userLogin: login,
  userLogout: logout,
};

export default connect(mapIvrStateToProps, mapDispatchToProps)(IvrListPage);
